import { DataContext } from "@/types";
import { Data } from "../Data";
import { SettingCourseFaculty } from "./SettingCourseFaculty";

export class SettingCourseFacultyList extends Data {
  static instance: SettingCourseFacultyList | null = null;
  faculties: any;

  constructor(options: any) {
    const { apiUrl, ...otherOptions } = options;
    const apiOptions = {
      api: apiUrl,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...otherOptions
    };

    super(apiOptions);

    this.faculties = [];
  }

  onDataReceived(data: any) {
    data.faculties.forEach((f: any, index: any) => {
      const faculty = new SettingCourseFaculty(f);
      this.faculties.push(faculty);
    });
  }

  static onGetData(context: any, options: any) {
    const { apiUrl } = options;
    return new Promise((resolve, reject) => {
      SettingCourseFacultyList.instance = new SettingCourseFacultyList({
        apiUrl,
        resolve,
        reject,
        context
      });
    });
  }

  static getSettingCourseFacultyList(context: DataContext, updateCache: boolean): Promise<SettingCourseFacultyList> {
    return new Promise((resolve, reject) => {
      if (SettingCourseFacultyList.instance && updateCache !== true)
        resolve(SettingCourseFacultyList.instance);
      else
        SettingCourseFacultyList.instance = new SettingCourseFacultyList({
          resolve,
          reject,
          context
        });
    });
  }
}
